// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"432":"7c907f1d","453":"9e2cf61b","557":"38058f33","779":"c2428e17","867":"bab8e482","880":"178745fb","956":"d7e51eba"}[chunkId] + ".chunk.js";
};